// extracted by mini-css-extract-plugin
export default {"claim-buttons":"claimForm_claim-buttons__lX2yA","claim-submit":"claimForm_claim-submit__eGey9"};